import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroupText,
  InputGroupAddon,
  InputGroup,
  FormGroup,
  CustomInput,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle, Tooltip
} from 'reactstrap';
import ReviewVoucher from './ReviewVoucher';

import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import PromosImagesForm from './PromosImagesForm';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
import {
  gAPI_Vouchers_By_Id,
  gAPI_QuestionOptionList, gAPI_Internal_Property_By_Id
} from '../../../../../../../constants/APIs';
import CatgeoryData from '../../../../../../../data/voucherCategory.json';
import searchTagsData from '../../../../../../../data/vocuherSearchTags.json';
import CustomSelectInput from '../../../../../../../components/common/CustomSelectInput';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageGallery from '../../../../propinfo/gallery/index';
import InviteVoucher from './InviteVoucher';

const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];
function VouchersForm({
  visible,
  toggle,
  formLabel,
  submit,
  updateVoucherData,
  id,
  propertyId, groupId, thirdPartyVoucher,
  handleReject,
  locale, ShowInviteVoucher,
  handleUpdate, invitationId,
  processingFee, approvalStatus
}) {
  const [isActive, setisActive] = useState(false);
  const [propertyData, setPropertyData] = useState({
    bmbVoucherProcessingFee: 0
  });
  const [voucherFeeData, setVoucherFeeData] = useState(false
  );
  // const [acceptModal, setAcceptModal] = useState(false);
  // const [rejectModal, setRejectModal] = useState(false);
  const [selectedTags, setselectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [imageIndex, setImageIndex] = useState(-1);
  const [error, seterror] = useState(false);
  const [showReviewVoucher, setShowReviewVoucher] = useState(false);
  let [voucherData, setVoucherData] = useState(
    updateVoucherData || {
      groupId: getGroupID(),
      propertyId: propertyId,
      name: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      introduction: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      details: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      conditions: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      url: '',
      status: 'Draft',
      price: 0,
      discountedPrice: 0,
      discount: 0,
      totalPurchaseLimit: 100,
      processingFee: 0,
      orderPurchaseLimit: 5,
      startDate: moment().format('YYYY-MM-DD'),
      expiryDate: moment().add(30, 'days').format('YYYY-MM-DD'),
      creator: 'Admin',
      sellingOptions: [],
      displayOrder: 1,
      taxPercentage: '0',
      searchTags: [],
      images: [],
      options: false,
      taxIncluded: 'true',
      taxAmount: '0',
      inventoryOptionLevel: false,
      giftEnabled: true,
      location: '',
      category: 'Accommodation',
      provider: 'RMS',
      includedItems: '',
      bookLater: false,
      instruction: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      redeemOption: '2',
    }
  );
  const [tooltipOpen, setTooltipOpen] = useState(false);
  useEffect(() => {
    if (id !== undefined) {
      setisActive(true);
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Vouchers_By_Id}/${id}`,
      }).then((res) => {
        if (res.data.taxIncluded === true) {
          let val = parseFloat(res.data.price) -
            parseFloat(res.data.taxIncluded === true ? res.data.taxAmount : 0);
          res.data.taxPercentage = ((parseFloat(res.data.taxAmount) * 100) / (
            val)
          ).toFixed(2);
        } else {
          res.data.taxPercentage = ((parseFloat(res.data.taxAmount) * 100) / (
            parseFloat(res.data.price) -
            parseFloat(res.data.taxIncluded === true ? res.data.taxAmount : 0))
          ).toFixed(2);
        }
        res.data.taxIncluded = res.data.taxIncluded.toString();
        setVoucherData(res.data);
        if (res.data.propertyId === propertyId) {
          loadProperty(res.data.propertyId, groupId === undefined ? getGroupID() : groupId);
        } else {
          loadProperty(res.data.propertyId, groupId === undefined ? getGroupID() : groupId);
        }
        AxiosAPI({
          method: 'get',
          url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Vouchers`,
        }).then((res1) => {
          var options = [];
          try {
            res1.data.map((item) =>
              options.push({
                label: item.option,
                value: item.option,
                key: item.id,
              })
            );
          } finally {
          }
          searchTagsData.data.map((m) => {
            options.push({
              label: m.name,
              value: m.value,
              key: m.value
            });
          });
          setTags(options);
          var selectedTags = [];
          try {
            res.data.searchTags.map((item) =>
              selectedTags.push(options.filter((cat) => cat.value === item)[0])
            );
          } finally {
          }
          setselectedTags(selectedTags);
        });
        //.catch((err) => console.log('err', err));
      });
      //.catch((err) => console.log('err', err));
    } else {
      loadProperty(propertyId, groupId === undefined ? getGroupID() : groupId);
      AxiosAPI({
        method: 'get',
        url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Vouchers`,
      }).then((res) => {
        var options = [];
        try {
          res.data.map((item) =>
            options.push({
              label: item.option,
              value: item.option,
              key: item.id,
            })
          );
        } finally {
        }
        searchTagsData.data.map((m) => {
          options.push({
            label: m.name,
            value: m.value,
            key: m.value
          });
        });
        setTags(options);
      });
      //.catch((err) => console.log('err', err));
    }
  }, [id]);
  const loadProperty = (propertyId, group_id) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${group_id}`,
    })
      .then((res) => {
        setPropertyData(res.data);
      })
  };
  const close_clicked = () => {
    setShowReviewVoucher(!showReviewVoucher);
  }
  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };
  const handleChangeNameArr = (e) => {
    if (voucherData.name.length > 0) {
      const index = voucherData.name.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          name: [...voucherData.name, newStatement],
        });
      } else {
        let newArr = [...voucherData.name];
        newArr[index].statement = e.target.value;
        setVoucherData({
          ...voucherData,
          name: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setVoucherData({
        ...voucherData,
        name: [...voucherData.name, newStatement],
      });
    }
  };
  const togglegallery = (index) => {
    setImageIndex(index);
    setGalleryVisible(!galleryVisible);
  };

  const selectedImage = (image) => {
    const newItems = [...voucherData.images];
    newItems[imageIndex].url = image.src;
    setVoucherData({
      ...voucherData,
      images: newItems,
    });
  };
  const handleCheckChange = (e) => {
    setVoucherData({
      ...voucherData,
      [e.target.name]: e.target.checked,
    });
  };
  const handleChangeIntroductionArr = (e) => {
    if (voucherData.introduction.length > 0) {
      const index = voucherData.introduction.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          introduction: [...voucherData.introduction, newStatement],
        });
      } else {
        let newArr = [...voucherData.introduction];
        newArr[index].statement = e.target.value;
        setVoucherData({
          ...voucherData,
          introduction: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setVoucherData({
        ...voucherData,
        introduction: [...voucherData.introduction, newStatement],
      });
    }
  };

  const handleChangeDetailsArr = (source, e) => {
    if (source === 'user') {
      if (voucherData.details.length > 0) {
        const index = voucherData.details.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setVoucherData({
            ...voucherData,
            details: [...voucherData.details, newStatement],
          });
        } else {
          let newArr = [...voucherData.details];
          newArr[index].statement = e;
          setVoucherData({
            ...voucherData,
            details: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          details: [...voucherData.details, newStatement],
        });
      }
    }
  };

  const handleChangeConditionsArr = (source, e) => {
    if (source === 'user') {
      if (voucherData.conditions.length > 0) {
        const index = voucherData.conditions.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setVoucherData({
            ...voucherData,
            conditions: [...voucherData.conditions, newStatement],
          });
        } else {
          let newArr = [...voucherData.conditions];
          newArr[index].statement = e;
          setVoucherData({
            ...voucherData,
            conditions: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          conditions: [...voucherData.conditions, newStatement],
        });
      }
    }
  };
  const handleInstructions = (source, e) => {
    if (source === 'user') {
      if (voucherData.instruction.length > 0) {
        const index = voucherData.instruction.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setVoucherData({
            ...voucherData,
            conditions: [...voucherData.instruction, newStatement],
          });
        } else {
          let newArr = [...voucherData.instruction];
          newArr[index].statement = e;
          setVoucherData({
            ...voucherData,
            instruction: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          instruction: [...voucherData.instruction, newStatement],
        });
      }
    }
  };

  const handleChangeTags = (selectedTags) => {
    setselectedTags(selectedTags);
    const tagsArr = selectedTags.map((elem) => elem.value);

    setVoucherData({
      ...voucherData,
      searchTags: tagsArr,
    });
  };
  const onTaxChange = (e) => {
    // setVoucherData({ ...voucherData, taxIncluded: e.target.value });    
    let val = parseFloat(voucherData.price) + parseFloat(e.target.value === 'true' ? 0 : 0);
    let val1 = 0;
    if (e.target.value === 'true') {
      let amount = ((parseFloat(voucherData.taxPercentage) + 100) / 100).toFixed(2);
      let tax = parseFloat(voucherData.price / amount).toFixed(2);
      val1 = parseFloat(voucherData.price - tax).toFixed(2);
    } else {
      val1 = (
        (parseFloat(voucherData.price) * parseFloat(voucherData.taxPercentage)) /
        100
      ).toFixed(2);
    }
    let discountedPrice = Math.round(
      (parseFloat(voucherData.price) + parseFloat(e.target.value === 'true' ? 0 : 0)) -
      (((parseFloat(voucherData.price) + parseFloat(e.target.value === 'true' ? 0 : 0)) * parseFloat(voucherData.discount)) / 100)

    );
    setVoucherData({
      ...voucherData,
      taxAmount: val1,
      taxIncluded: e.target.value,
      discountedPrice: discountedPrice

    });

    // handleTaxAmount(voucherData.taxPercentage);
    // voucherData.taxIncluded = e.target.value;
  }
  const handleChange = (e) => {
    if (e.target.name === 'discount' && e.target.value !== '') {
      let val = parseFloat(voucherData.price) + parseFloat(voucherData.taxIncluded === 'true' ? 0 : 0);
      let val1 = 0;
      if (voucherData.taxIncluded === 'true') {
        let amount = ((parseFloat(voucherData.taxPercentage) + 100) / 100).toFixed(2);
        let tax = parseFloat(voucherData.price / amount).toFixed(2);
        val1 = parseFloat(voucherData.price - tax).toFixed(2);
      } else {
        val1 = (
          (parseFloat(voucherData.price) * parseFloat(voucherData.taxPercentage)) /
          100
        ).toFixed(2);
      }
      setVoucherData({
        ...voucherData,
        [e.target.name]: e.target.value,
        taxAmount: val1,
        discountedPrice: Math.round(
          (parseFloat(voucherData.price) + parseFloat(voucherData.taxIncluded === 'true' ? 0 : 0)) -
          ((val * parseFloat(e.target.value)) / 100)
        ),
      });

    } else if (e.target.name === 'price' && e.target.value !== '') {
      let val = 0;
      if (voucherData.taxIncluded === 'true') {
        let amount = ((parseFloat(voucherData.taxPercentage) + 100) / 100).toFixed(2);
        let tax = parseFloat(e.target.value / amount).toFixed(2);
        val = parseFloat(e.target.value - tax).toFixed(2);
      } else {
        val = (
          (parseFloat(e.target.value) * parseFloat(voucherData.taxPercentage)) /
          100
        ).toFixed(2);
      }
      let totalprice = parseFloat(e.target.value) + parseFloat(voucherData.taxIncluded === 'true' ? 0 : 0);
      setVoucherData({
        ...voucherData,
        [e.target.name]: e.target.value,
        taxAmount: val,
        discountedPrice: Math.round(
          totalprice -
          (totalprice * parseFloat(voucherData.discount) /
            100)
        ),
      });

    } else {
      setVoucherData({
        ...voucherData,
        [e.target.name]: e.target.value,
      });
    }

  };

  const handleSubmit = () => {
    if (voucherData.name[0].statement === '' || voucherData.introduction[0].statement === '' ||
      voucherData.conditions[0].statement === '' || voucherData.details[0].statement === '' ||
      voucherData.totalPurchaseLimit === 0 || voucherData.orderPurchaseLimit === 0 || voucherData.price === 0 ||
      voucherData.instruction[0].statement === '' || voucherData.instruction[0].statement === '<p><br></p>' ||
      voucherData.introduction[0].statement === '<p><br></p>' || voucherData.introduction[0].statement === '<p><br></p>' ||
      voucherData.conditions[0].statement === '<p><br></p>' || voucherData.name[0].statement === '<p><br></p>' || voucherData.taxAmount === '' || (voucherData.taxIncluded === '' && voucherData.taxIncluded !== false)
    ) {
      seterror(true);
      voucherData.status = 'Draft';
    }
    else
      submit(voucherData);
  };

  const handleImageChange = (e, index) => {
    e.persist();
    const newItems = [...voucherData.images];
    newItems[index][e.target.name] = e.target.value;
    setVoucherData({
      ...voucherData,
      images: newItems,
    });
  };
  const createUUID = () => {
    const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return pattern.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  const deleteImage = (index) => {
    const values = [...voucherData.images];
    values.splice(index, 1);
    setVoucherData({ ...voucherData, images: values });
  };

  const addImage = () => {
    const values = [...voucherData.images];
    values.push({
      url: '',
      displayOrder: 0,
    });
    setVoucherData({ ...voucherData, images: values });
  };
  const handleTaxAmount = (percentage) => {
    let val = 0;
    if (voucherData.taxIncluded === 'true') {
      let amount = ((parseFloat(percentage) + 100) / 100).toFixed(2);
      let tax = parseFloat(voucherData.price / amount).toFixed(2);
      val = parseFloat(voucherData.price - tax).toFixed(2);
    } else {
      val = (
        (parseFloat(voucherData.price) * parseFloat(percentage)) /
        100
      ).toFixed(2);

    }
    let discountedPrice = Math.round(
      (parseFloat(voucherData.price) +
        parseFloat(voucherData.taxIncluded === 'true' ? 0 : 0)) -
      (((parseFloat(voucherData.price) +
        parseFloat(voucherData.taxIncluded === 'true' ? 0 : 0)) * parseFloat(voucherData.discount)) / 100)
    );
    setVoucherData({ ...voucherData, taxPercentage: percentage, taxAmount: val, discountedPrice: discountedPrice });
  }
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleAddIncludedItems = (name) => {
    if (voucherData.includedItems.split(',').includes(name.trim(''))) {
      let includeItemsList = voucherData.includedItems.split(',');
      let itemsList = includeItemsList.filter((e) => e !== name);
      setVoucherData({
        ...voucherData,
        includedItems: itemsList.toString(),
      });
    } else {
      setVoucherData({
        ...voucherData,
        includedItems: voucherData.includedItems + ',' + name,
      });
    }
  };
  const handleLocation = (e) => {
    setVoucherData({
      ...voucherData,
      location: e.target.value,
    });
  };
  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggle}
        size="lg"
        style={{ maxWidth: '1000px' }}
      >
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              {/* <pre>{JSON.stringify(voucherData, null, 2)}</pre> */}
              <Row>
                <Colxx sm={6} className="mb-3">
                  <Label>Title<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="textarea"
                    maxLength={50}
                    value={getLocalStatement(voucherData.name)}
                    onChange={handleChangeNameArr}
                    name="name"
                    style={{ height: '50px' }}
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Introduction<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="textarea"
                    value={getLocalStatement(voucherData.introduction)}
                    onChange={handleChangeIntroductionArr}
                    name="introduction"
                    style={{ height: '50px' }}
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Details<span style={{ color: 'red' }}> *</span></Label>
                  <ReactQuill
                    theme="snow"
                    value={getLocalStatement(voucherData.details)}
                    onChange={(content, delta, source) =>
                      handleChangeDetailsArr(source, content)
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    name="details"
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Conditions<span style={{ color: 'red' }}> *</span></Label>
                  <ReactQuill
                    theme="snow"
                    value={getLocalStatement(voucherData.conditions)}
                    onChange={(content, delta, source) =>
                      handleChangeConditionsArr(source, content)
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    name="conditions"
                  />
                </Colxx>
                {/* <Colxx sm={6} className="mb-3">
                  <Label>Instructions</Label>
                  {<ReactQuill
                    theme="snow"
                    value={getLocalStatement(voucherData.instruction)}
                    onChange={(content, delta, source) =>
                      handleChangeInstructionsArr(source, content)
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    name="instruction"
                  />}
                </Colxx> */}
                <Colxx sm={3} className="mb-3">
                  <Label>Start Date<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    required
                    type="date"
                    name="startDate"
                    value={moment(voucherData.startDate).format('YYYY-MM-DD')}
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Expiry Date<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    required
                    type="date"
                    name="expiryDate"
                    value={moment(voucherData.expiryDate).format('YYYY-MM-DD')}
                    onChange={handleChange}
                  />
                </Colxx>

                <Colxx sm={3} className="mb-3">
                  <Label>Status<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="select"
                    value={voucherData.status}
                    name="status"
                    onChange={handleChange}
                  >
                    <option value="Draft">Draft</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Archived">Archived</option>
                  </Input>
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Primary Business Category<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="select"
                    value={
                      voucherData.category === undefined || null
                        ? 'Wine'
                        : voucherData.category
                    }
                    name="category"
                    onChange={(f) => {
                      setVoucherData({
                        ...voucherData,
                        category: f.target.value,
                      });
                    }}
                  >
                    {CatgeoryData.data !== undefined &&
                      CatgeoryData.data.map((m) => {
                        return <option value={m.value}>{m.name}</option>;
                      })}
                  </Input>
                </Colxx>
                <Colxx sm={6}>
                  <FormGroup>
                    <Label for="bookingUrl">Search Tags</Label>
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti={true}
                      name="form-field-name"
                      value={selectedTags}
                      onChange={handleChangeTags}
                      options={tags}
                    />
                  </FormGroup>
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Allow Gifting</Label>
                  <CustomInput
                    type="checkbox"
                    id="giftEnabled"
                    checked={voucherData.giftEnabled}
                    name="giftEnabled"
                    onChange={handleCheckChange}
                  />
                </Colxx>
                <Colxx sm={3}>
                  <Label for="displayOrder">Display Order</Label>
                  <Input
                    type="number"
                    name="displayOrder"
                    min={0}
                    value={voucherData.displayOrder}
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={3} style={{ display: 'none' }}>
                  <Label for="displayOrder">Location</Label>
                  <Input
                    type="text"
                    name="displayOrder"
                    min={0}
                    value={voucherData.location}
                    onChange={handleLocation}
                  />
                </Colxx>

              </Row>

              <Row className="mb-2">
                <Colxx sm={12}>
                  <h4>What`s Included ?</h4>
                </Colxx>
                <Colxx sm={12}>
                  <Row className="mb-4">
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems
                            .split(',')
                            .includes('Night Stay')
                            ? true
                            : false
                        }
                        value="Night Stay"
                        onChange={() => handleAddIncludedItems('Night Stay')}
                      >
                        <span style={{ lineHeight: '23px' }}>Night Stay</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems
                            .split(',')
                            .includes('Breakfast')
                            ? true
                            : false
                        }
                        value="Breakfast"
                        onChange={() => handleAddIncludedItems('Breakfast')}
                      >
                        <span style={{ lineHeight: '23px' }}>Breakfast</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems
                            .split(',')
                            .includes('Bike Hire')
                            ? true
                            : false
                        }
                        value="Bike Hire"
                        onChange={() => handleAddIncludedItems('Bike Hire')}
                      >
                        <span style={{ lineHeight: '23px' }}>Bike Hire</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems
                            .split(',')
                            .includes('Drinks')
                            ? true
                            : false
                        }
                        value="Drinks"
                        onChange={() => handleAddIncludedItems('Drinks')}
                      >
                        <span style={{ lineHeight: '23px' }}>Drinks</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems.split(',').includes('Pool')
                            ? true
                            : false
                        }
                        value="Pool"
                        onChange={() => handleAddIncludedItems('Pool')}
                      >
                        <span style={{ lineHeight: '23px' }}>Pool</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems
                            .split(',')
                            .includes('Shopping')
                            ? true
                            : false
                        }
                        value="Shopping"
                        onChange={() => handleAddIncludedItems('Shopping')}
                      >
                        <span style={{ lineHeight: '23px' }}>Shopping</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems
                            .split(',')
                            .includes('High Tea')
                            ? true
                            : false
                        }
                        value="High Tea"
                        onChange={() => handleAddIncludedItems('High Tea')}
                      >
                        <span style={{ lineHeight: '23px' }}>High Tea</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems.split(',').includes('Golf')
                            ? true
                            : false
                        }
                        value="Golf"
                        onChange={() => handleAddIncludedItems('Golf')}
                      >
                        <span style={{ lineHeight: '23px' }}>Golf</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems
                            .split(',')
                            .includes('Restaurant')
                            ? true
                            : false
                        }
                        value="Restaurant"
                        onChange={() => handleAddIncludedItems('Restaurant')}
                      >
                        <span style={{ lineHeight: '23px' }}>Restaurant</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems.split(',').includes('Room')
                            ? true
                            : false
                        }
                        value="Room"
                        onChange={() => handleAddIncludedItems('Room')}
                      >
                        <span style={{ lineHeight: '23px' }}>Room</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems
                            .split(',')
                            .includes('Beach Access')
                            ? true
                            : false
                        }
                        value="Beach Access"
                        onChange={() => handleAddIncludedItems('Beach Access')}
                      >
                        <span style={{ lineHeight: '23px' }}>Beach Access</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems
                            .split(',')
                            .includes('Camping Site')
                            ? true
                            : false
                        }
                        value="Camping Site"
                        onChange={() => handleAddIncludedItems('Camping Site')}
                      >
                        <span style={{ lineHeight: '23px' }}>Camping Site</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems.split(',').includes('Ski')
                            ? true
                            : false
                        }
                        value="Ski"
                        onChange={() => handleAddIncludedItems('Ski')}
                      >
                        <span style={{ lineHeight: '23px' }}>Ski</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems.split(',').includes('Parking')
                            ? true
                            : false
                        }
                        value="Parking"
                        onChange={() => handleAddIncludedItems('Parking')}
                      >
                        <span style={{ lineHeight: '23px' }}>Parking</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems.split(',').includes('Transfers')
                            ? true
                            : false
                        }
                        value="Transfers"
                        onChange={() => handleAddIncludedItems('Transfers')}
                      >
                        <span style={{ lineHeight: '23px' }}>Transfers</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems.split(',').includes('Pets Allowed')
                            ? true
                            : false
                        }
                        value="Pets Allowed"
                        onChange={() => handleAddIncludedItems('Pets Allowed')}
                      >
                        <span style={{ lineHeight: '23px' }}>Pets Allowed</span>
                      </CustomInput>
                    </Colxx>
                    <Colxx sm={3}>
                      <CustomInput
                        type="checkbox"
                        checked={
                          voucherData.includedItems.split(',').includes('Sauna/Hot Tub')
                            ? true
                            : false
                        }
                        value="Sauna/Hot Tub"
                        onChange={() => handleAddIncludedItems('Sauna/Hot Tub')}
                      >
                        <span style={{ lineHeight: '23px' }}>Sauna/Hot Tub</span>
                      </CustomInput>
                    </Colxx>
                  </Row>
                </Colxx>
              </Row>

              <Row className="mb-2">
                <Colxx sm={12}>
                  <h4>Images</h4>
                </Colxx>
                <Colxx sm={12}>
                  {voucherData.images.length > 0 &&
                    voucherData.images.map((image, index) => (
                      <Row key={`${image}~${index}`}>
                        <Colxx sm={2} className="md-3">
                          <img
                            style={{
                              width: '100%',
                              height: '90%',
                            }}
                            alt="room image"
                            src={
                              image.url || 'https://via.placeholder.com/150/'
                            }
                          />
                        </Colxx>

                        <Colxx sm={3} className="mb-3">
                          <Label>Image Display Order</Label>
                          <Input
                            type="number"
                            name="displayOrder"
                            min={1}
                            value={image.displayOrder}
                            onChange={(event) =>
                              handleImageChange(event, index)
                            }
                          />
                        </Colxx>
                        <Colxx sm={1} className="mb-3">
                          <Label>Browse</Label>
                          <div
                            className="iconsminds-photo"
                            onClick={(event) => togglegallery(index)}
                            style={{
                              cursor: 'pointer',
                              fontSize: '28px',
                              color: '#73236b',
                            }}
                          ></div>
                        </Colxx>
                        <Colxx sm={1} className="mb-3">
                          <Label>Remove</Label>
                          <div>
                            <Button
                              onClick={() => deleteImage(index)}
                              color="secondary"
                              size="xs"
                              outline
                              style={{ margin: '6px' }}
                            >
                              -
                            </Button>
                          </div>
                        </Colxx>
                      </Row>
                    ))}
                </Colxx>

                <Button
                  onClick={addImage}
                  color="primary"
                  size="xs"
                  outline
                  style={{ margin: '6px' }}
                >
                  + Add image
                </Button>
              </Row>
              <hr></hr>
              <Row className="mb-2">
                <Colxx sm={12}>
                  <h4>Pricing & Inventory</h4>
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Retail Price<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="number"
                    min={0}
                    value={voucherData.price}
                    name="price"
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Discount</Label>
                  <InputGroup>
                    <Input
                      type="number"
                      min={0}
                      value={voucherData.discount}
                      name="discount"
                      onChange={(e) => { handleChange(e); }}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>%</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Price After Discount</Label>
                  <Input
                    type="number"
                    min={0}
                    value={voucherData.discountedPrice}
                    name="discountedPrice"
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <FormGroup>
                    <Label>  Myma.ai Processing Fee
                    </Label>
                    <InputGroup>

                      <Input
                        type="number"
                        name="bmbVoucherProcessingFee"
                        id="bmbVoucherProcessingFee"
                        onChange={handleChange}
                        disabled={true}
                        value={propertyData.bmbVoucherProcessingFee}
                      />
                      <InputGroupAddon addonType='append' >
                        <InputGroupText>%</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>

                  </FormGroup>
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Tax included in price <span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="select"
                    value={voucherData.taxIncluded}
                    name="taxIncluded"
                    onChange={(f) => {
                      onTaxChange(f);

                    }}
                  >
                    <option value='true' >Yes</option>
                    <option value='false'>No</option>
                  </Input>
                </Colxx>
                <Colxx sm={3}>
                  <Label for="tax_Percentage">Tax Percentage <span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="text"
                    name="taxPercentage"
                    min={0}
                    value={voucherData.taxPercentage !== NaN ? voucherData.taxPercentage : 0}
                    onChange={(e) => {
                      handleTaxAmount(e.target.value);

                    }}
                  />
                </Colxx>
                <Colxx sm={3} >
                  <Label for="tax_Amount">Tax Amount<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="text"
                    disabled={true}
                    name="taxAmount"
                    min={0}
                    value={voucherData.taxAmount}
                    onChange={(e) => { setVoucherData({ ...voucherData, taxAmount: e.target.value }) }}
                  />
                </Colxx>
              </Row>

              <Row className="mb-1">

                <Colxx sm={3} className="mb-3">
                  <Label>Total Available to Sell<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="number"
                    min={0}
                    value={voucherData.totalPurchaseLimit}
                    name="totalPurchaseLimit"
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Order Purchase Limit<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="number"
                    min={0}
                    value={voucherData.orderPurchaseLimit}
                    name="orderPurchaseLimit"
                    onChange={handleChange}
                  />
                </Colxx><Colxx sm={3} className="mb-3">
                  <Label>Enable Multiple Choices</Label>
                  <CustomInput
                    type="checkbox"
                    checked={voucherData.options}
                    name="options"
                    onChange={handleCheckChange}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Manage Inventory at Choice Level</Label>
                  <CustomInput
                    type="checkbox"
                    checked={voucherData.inventoryOptionLevel}
                    name="inventoryOptionLevel"
                    onChange={handleCheckChange}
                  />
                </Colxx>


              </Row>
            </Colxx>




          </Row>
          <hr></hr>
          <Row className="mb-1">
            <Colxx sm={12} className="mb-2">
              <h4>Redeem Instructions</h4>
            </Colxx>
            <Colxx sm={3} className="mb-3">
              <Label>Redeem Mechanism<span style={{ color: 'red' }}> *</span></Label>
              <Input
                type="select"
                value={voucherData.redeemOption}
                name="redeemOption"
                onChange={(f) => {
                  setVoucherData({
                    ...voucherData,
                    redeemOption: f.target.value,
                  });
                }}
              >
                <option
                  value="2"
                  selected={
                    voucherData.redeemOption === '3'
                      ? true
                      : false
                  }
                >
                  Instructions
                </option>
                <option
                  value="3"
                  selected={
                    voucherData.redeemOption === '4'
                      ? true
                      : false
                  }
                >
                  aiva Integrations
                </option>
              </Input>
            </Colxx>

            <Colxx sm={4} className="d-none mb-3">
              <FormGroup>
                <Label>  Add Your Fee (for partner vouchers)
                </Label>
                <InputGroup>
                  <Input
                    type="number"
                    name="processingFee"
                    id="processingFee"
                    onChange={(f) => {
                      setVoucherData({
                        ...voucherData,
                        processingFee: f.target.value,
                      });
                    }}
                    value={processingFee !== undefined && processingFee !== '' ? parseFloat(processingFee) : parseFloat(voucherData.processingFee)}
                  />
                  <InputGroupAddon addonType='append' >
                    <InputGroupText>%</InputGroupText>
                  </InputGroupAddon>

                </InputGroup>

              </FormGroup>
            </Colxx>
            {voucherData.redeemOption !== 'BookMeBob' && <Colxx sm={6} className="mb-3">
              <Label>Instructions<span style={{ color: 'red' }}> *</span></Label>
              <ReactQuill
                theme="snow"
                value={getLocalStatement(voucherData.instruction)}
                onChange={(content, delta, source) =>
                  handleInstructions(source, content)
                }
                modules={quillModules}
                formats={quillFormats}
                name="instruction"
              />
            </Colxx>} </Row>

        </ModalBody >
        <ModalFooter>
          {/* <Button color="primary">
            Invite others to Sell
          </Button>
          <Button color="secondary" onClick={() => setRejectModal(!rejectModal)}>
            Reject to Sell
          </Button>
          <Button color="primary" onClick={() => setAcceptModal(!acceptModal)}>
            Accept to Sell
          </Button> */}
          <Button color="primary" onClick={() => setShowReviewVoucher(!showReviewVoucher)} style={{ background: 'gray' }}>
            Preview <i className='iconsminds-share'></i>
          </Button>
          {approvalStatus !== undefined && approvalStatus === '1' && processingFee !== undefined && <Fragment>
            <Button color="primary" onClick={() => handleUpdate('Approve')}>
              Approve
            </Button>
            <Button color="primary" onClick={() => handleUpdate('Reject')}>
              Reject
            </Button>
          </Fragment>}
          {processingFee === undefined &&
            <Fragment>
              {InviteVoucher !== undefined && <Button color="primary" onClick={ShowInviteVoucher}>
                Invite
              </Button>}
              <Button color="primary" onClick={handleSubmit}>
                Save
              </Button>

            </Fragment>}

          {thirdPartyVoucher && approvalStatus === '2' &&
            < Button
              key='Selling'
              onClick={() => {
                handleReject(voucherData.id, invitationId, 'StopSelling', voucherData.processingFee);
                toggle();
              }}
            >
              Stop Selling
            </Button>
          }
          {thirdPartyVoucher && approvalStatus === '4' &&
            <Button
              key='Reject'
              onClick={() => {
                handleReject(voucherData.id, invitationId, 'Approve', voucherData.processingFee);
                toggle();
              }}
            >
              Start Selling
            </Button>
          }

          <Button color="secondary" onClick={() => { toggle(); setShowReviewVoucher(!showReviewVoucher); }}>
            Close
          </Button>
        </ModalFooter>
      </Modal >
      {ImageGalleryButton()}
      <Modal isOpen={error} toggle={() => seterror(!error)
      }>
        <ModalHeader toggle={() => seterror(!error)}>
          Voucher
        </ModalHeader>
        <ModalBody>
          <p className="m-auto">
            "The Voucher has been saved as draft as some of the mandatory information is missing.
            Please complete and make the Voucher Active when ready"
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { seterror(!error); submit(voucherData); }}>
            Close
          </Button>
        </ModalFooter>
      </Modal >
      {/*   <Modal isOpen={acceptModal} toggle={() => setAcceptModal(!acceptModal)}>
        <ModalHeader toggle={() => setAcceptModal(!acceptModal)}>
          Accept to Sell
        </ModalHeader>
        <ModalBody>
          On acceptance, this voucher will be made available on your channels to sell
        </ModalBody>
        <ModalFooter>
          <Button color="primary">
            Accept
          </Button>
          <Button color="secondary" onClick={() => setAcceptModal(!acceptModal)} >
            Cancel
          </Button>
        </ModalFooter>
      </Modal> */}
      {showReviewVoucher && <ReviewVoucher close_clicked={close_clicked} locale={locale} isCheckoutView={false} propertyData={propertyData} isVoucherEngine={true} data={voucherData}></ReviewVoucher>}
    </Fragment >
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(VouchersForm));
